import * as THREE from 'three'
import Experience from "../Experience.js"

export default class Mizuburo
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time

        // Setup
        this.resource = this.resources.items.mizuburoModel

        this.setModel()
    }

    setModel()
    {
        this.model = this.resource.scene
        this.model.scale.set(1, 1, 1)
        this.model.position.set(-1, 0, 1.25)
        this.model.traverse((child) =>
        {
            child.castShadow = true
            child.receiveShadow = true
        })
        this.scene.add(this.model)
    }
}